import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=695d9b48&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=695d9b48&prod&lang=less&scoped=true"
import style1 from "./comment.vue?vue&type=style&index=1&id=695d9b48&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695d9b48",
  null
  
)

export default component.exports